module.exports = __webpack_public_path__ + "static/img/arnergy-5000.5c8e7de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arnergy-5000.png
// module id = 445
// module chunks = 1